import { render, staticRenderFns } from "./codappointnew.vue?vue&type=template&id=17cff89e&scoped=true"
import script from "./codappointnew.vue?vue&type=script&lang=js"
export * from "./codappointnew.vue?vue&type=script&lang=js"
import style0 from "./codappointnew.vue?vue&type=style&index=0&id=17cff89e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cff89e",
  null
  
)

export default component.exports